import { useState, useEffect } from 'react';
import { Button} from '@mui/material';
import { useAuth } from '../../../contexts/AuthContext';
import { usePost } from '../../../apis/ApiRequests';
import Header from '../../../components/uiParts/port/Header';
import TitleBar from '../../../components/uiParts/TitleBar';

const FisherManList = () => {
    
    const { authInfo, setAuthInfo } = useAuth();

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const facilityCode = authInfo.facilityCode;
    const facilityName = authInfo.facilityName;
    const userId       = authInfo.userId;
    const userName     = authInfo.userName;
    const authority    = authInfo.authority;
    const traderCode   = authInfo.traderCode;
    const trader       = authInfo.trader;
    
	//===============================================
	// API
	//===============================================
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {
    },[])

	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 日付の変更
	//-----------------------------------------------
    const handleChange_entryDate = (value) => {
    };
	//===============================================
	// Function
	//===============================================
	//===============================================
	// UI Message
	//===============================================
	//===============================================
	// イベントハンドラ
	//===============================================
    //===============================================
    // Css
    //===============================================
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/portMastaMenu" setEntryDate={handleChange_entryDate} />
            <div className='fisherManList bodyContens'>
                <TitleBar title="漁業者マスタ" color="#006400" />
            </div>
        </>
    )
}
export default FisherManList;